
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { ObjectFeaturesEnum } from "../../common/enums/ObjectFeaturesEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IEntityValueDeviceModel, IEntityValueTagModel, IEntityValueTankModel, IEntityValueWellModel } from "../../common/models/IEntityValueModels";
import { ILookupListText } from "../../common/models/ILookupList";
import { ISortParameters } from "../../common/models/ISortParameters";
import { ITagCategory } from "../../common/models/ITagCategory";
import { ITagValue } from "../../common/models/ITagValue";
import { ITankBattery, ITankBatteryTank } from "../../common/models/ITankBattery";
import { ITankStyle } from "../../common/models/TankStyle";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import { IOfflineDevice, IOfflineListText, IOfflinePendingTagValue, IOfflineTag, IOfflineTank, IOfflineTankBattery, IOfflineWell } from "../offline-data-service/Models";
import OfflineDataService from "../offline-data-service/OfflineDataService";
import restService from "../rest-service/RestService";
import { ITagHistory } from "../tag-data-service/Models";
import { ITagAndTatID } from "./Models";


export interface IObjectTagValuesExportRestQueryParams {
    notificationKey: string;
    mimeType: ApplicationMimeTypesEnum;
    sortParameters: ISortParameters;
    optionalColumns: Array<string>;
}

const projectDevice = (offlineDevice: IOfflineDevice,
    offlineListText: IOfflineListText[],
    tankStyles: ITankStyle[],
    pendingValues: IOfflinePendingTagValue[],
    useLKVOffline: boolean
): IEntityValueDeviceModel => {

    const tankStyle = tankStyles.find(o => o.id === offlineDevice.tankStyleID as number);

    const device: IEntityValueDeviceModel = {
        id: offlineDevice?.id,
        objectType: eLynxObjectTypeEnum.Device,
        objectName: offlineDevice?.name,
        displayText: offlineDevice?.name,
        tags: offlineDevice.tags?.map((v) => {
            return projectTag(v, offlineListText, pendingValues, useLKVOffline);
        }) ?? [],
        tanks: offlineDevice.tanks?.map((v) => {
            return projectTank(v, offlineListText, tankStyles, pendingValues, useLKVOffline);
        }) ?? [],
        features: offlineDevice.features,
        gasAnalysisTolerance: 0,
        demandScanBeforeWrite: true,
        deviceType: offlineDevice.deviceTypeID,
        subTypeID: offlineDevice.subTypeID,
        lookupLists: [],
        categories: [],
        tankStyle: tankStyle as ITankStyle        
    };

    return device;
};

const projectTank = (offlineTank: IOfflineTank,
    offlineListText: IOfflineListText[],
    tankStyles: ITankStyle[],
    pendingValues: IOfflinePendingTagValue[],
    useLKVOffline: boolean
): IEntityValueTankModel => {

    
    const tank: IEntityValueTankModel = {
        ...projectDevice(offlineTank as IOfflineDevice, offlineListText, tankStyles, pendingValues, useLKVOffline) as IEntityValueDeviceModel
    };

    //tank.order = ??

    return tank;
};

const projectTankBattery = (offlineTankBattery: IOfflineTankBattery,
    offlineListText: IOfflineListText[],
    tankStyles: ITankStyle[],
    pendingValues: IOfflinePendingTagValue[],
    useLKVOffline: boolean): ITankBattery => {

    const item: ITankBattery = {
        id: offlineTankBattery.id,
        objectType: eLynxObjectTypeEnum.TankBattery,
        objectName: offlineTankBattery?.name,
        displayText: offlineTankBattery?.name,
        tags: offlineTankBattery.tags?.map((v) => {
            return projectTag(v, offlineListText, pendingValues, useLKVOffline);
        }) ?? [],
        tankStyles: tankStyles,
        devices: [],
        categories: [],

        tanks: offlineTankBattery.tanks?.map((v) => {

            return {
                id: v.id,
                objectType: eLynxObjectTypeEnum.Tank,
                objectName: v.name,
                displayText: v.name,
                tags: v.tags?.map((x) => {
                    return projectTag(x, offlineListText, pendingValues, useLKVOffline);
                }) ?? [],
                tankStyleID: v.tankStyleID,
                subTypeID: v.subTypeID

            } as ITankBatteryTank;

        }) ?? [],

    };

    return item;
};



const projectWell = (offlineWell: IOfflineWell,
    offlineListText: IOfflineListText[],
    tankStyles: ITankStyle[],
    pendingValues: IOfflinePendingTagValue[],
    useLKVOffline: boolean): IEntityValueWellModel => {

    const item: IEntityValueWellModel = {
        id: offlineWell.id,
        objectType: eLynxObjectTypeEnum.Well,
        objectName: offlineWell?.name,
        displayText: offlineWell?.name,
        features: ObjectFeaturesEnum.ManualEntry,
        lookupLists: [],
        categories: [],
        tags: offlineWell.tags?.map((v) => {
            return projectTag(v, offlineListText, pendingValues, useLKVOffline);
        }) ?? [],
        devices: offlineWell.devices?.map((v) => projectDevice(v, offlineListText, tankStyles, pendingValues, useLKVOffline)) ?? [],

    };

    return item;
};


const projectTag = (offlineTag: IOfflineTag,
    offlineListText: IOfflineListText[],
    pendingValues: IOfflinePendingTagValue[],
    useLKVOffline: boolean): IEntityValueTagModel => {

    const pendingValue = pendingValues.sort((o, v) => Date.parse(v.ts).valueOf() - Date.parse(o.ts).valueOf()).find(o => o.tagID === offlineTag.id);

    const item: IEntityValueTagModel = {
        id: offlineTag.id,
        objectType: eLynxObjectTypeEnum.Tag,
        tatID: offlineTag.tatID,
        displayText: offlineTag.name,
        dataType: offlineTag.dataType,
        //color?: string;
        decimalPlaces: offlineTag.decimals,
        writeLowerBound: offlineTag.lwrBnd,
        writeLowerBoundOp: offlineTag.lwrBndOp,
        writeUpperBound: offlineTag.upprBnd,
        writeUpperBoundOp: offlineTag.upprBndOp,
        uomID: offlineTag.uomID,
        //unitDisplayName?: string;
        listID: offlineTag.lstID,
        //tagValue?: ITagValue;
        features: offlineTag.features,

        //categoryID: offlineTag.categoryID,
        categoryID: offlineTag.category?.value,
        categoryName: offlineTag.category?.key,
        categoryOrder: offlineTag.category?.value,

        tagObjectID: offlineTag.objID,
        tagObjectType: offlineTag.objType,
        tagObject: {
            id: offlineTag.objID,
            objectType: offlineTag.objType
        },
        // tagValue: {
        //     value: pendingValue?.val ?? undefined,
        //     displayText: pendingValue?.txt ?? '',
        //     tagID: offlineTag.id,
        //     unitOfMeasureID: offlineTag.uomID,
        //     timestamp: pendingValue?.ts ?? undefined
        // }
    };

    if (pendingValue) {
        item.tagValue = {
            value: pendingValue.val,
            displayText: pendingValue.txt,
            tagID: offlineTag.id,
            unitOfMeasureID: offlineTag.uomID,
            timestamp: pendingValue.ts
        }
    } else if (useLKVOffline && offlineTag.val !== undefined) {

        item.tagValue = {
            value: offlineTag.val,
            displayText: offlineTag.val?.toString(),
            tagID: offlineTag.id,
            unitOfMeasureID: offlineTag.uomID,
            unitDisplayName: offlineTag.uomName,
            timestamp: offlineTag.ts?.toString()
        }

        if (!item.unitDisplayName) {
            item.unitDisplayName = offlineTag.uomName
        }
    }

    if (offlineTag.lstID) {
        const filtered = offlineListText.filter(o => o.lstID === offlineTag.lstID);
        const listText = filtered.map((o) => {
            return {
                id: o.val,
                description: o.txt,
                value: o.val.toString(),
                listID: offlineTag.lstID as number,
                //selectOrder: 0,
            } as ILookupListText;
        });

        item.lookupList = {
            id: offlineTag.lstID,
            description: '',
            readOnly: false,
            listText: listText
        };
    }

    return item;
};

const setLookupList = (entity: IEntityValueDeviceModel | IEntityValueTankModel | IEntityValueWellModel): void => {

    entity.tags.forEach((o) => {
        if (o.listID) {
            o.lookupList = entity.lookupLists.find(v => v.id === o.listID);
        }
    });
};

export type TagValueDataQueryParams = {
    date?: string;
    contextGroupID?: number;
    convertToContractday?: boolean;
    configurationID?: number;
};

type GetObjectValuesChartsQueryParams = {
    tagIDTatIDs: Array<ITagAndTatID>;
    startTime: Date | undefined;
    endTime: Date | undefined;
}


const TagValueDataService = {

    getTagValueData: async function (customerID: number,
        contextGroupID: number,
        eLynxObject: IeLynxObject,
        date: Date | undefined,
        offline: boolean,
        useLKVOffline: boolean,
        configurationID?: number,
        signal?: AbortSignal):
        Promise<IEntityValueDeviceModel | IEntityValueTankModel | IEntityValueWellModel | ITankBattery | undefined> {

        if (!offline) {
            const path = `/groups/${contextGroupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/values`;
            switch (eLynxObject.objectType) {
                case eLynxObjectTypeEnum.Device:
                    const deviceResponse = await restService.get<IEntityValueDeviceModel, TagValueDataQueryParams>(path, signal, { 
                        date: date ? `${date.toISOString()}` : undefined ,
                        configurationID: configurationID
                    });
                    setLookupList(deviceResponse.data);
                    return deviceResponse.data;

                case eLynxObjectTypeEnum.Tank:
                    const tankResponse = await restService.get<IEntityValueTankModel>(path, signal);
                    setLookupList(tankResponse.data);
                    return tankResponse.data;

                case eLynxObjectTypeEnum.Well:
                    const wellResponse = await restService.get<IEntityValueWellModel>(path, signal);
                    setLookupList(wellResponse.data);
                    return wellResponse.data;

                case eLynxObjectTypeEnum.TankBattery:

                    const tankBatteryResponse = await restService.get<ITankBattery>(path, signal);
                    return tankBatteryResponse.data;

                default:
                    throw new Error(`getTagValues not implemented for ${eLynxObject.objectType}`);
            }

        } else {

            const p1 = OfflineDataService.getObject(customerID,
                eLynxObject,
                ObjectFeaturesEnum.ManualEntry, {
                includeTanks: true,
                includeTags: true
            });

            const p2 = OfflineDataService.getLookupLists(customerID);
            const p3 = OfflineDataService.getTankStyles(customerID);

            const [offlineObject, offlineListText, tankStyles] = await Promise.all([p1, p2, p3]);

            if (offlineObject) {
                switch (eLynxObject.objectType) {
                    case eLynxObjectTypeEnum.Device:

                        const offlineDevice = offlineObject as IOfflineDevice;

                        let tagIDs = offlineDevice?.tags?.map(o => o.id) ?? [];


                        offlineDevice.tanks?.forEach(o => {
                            tagIDs = tagIDs.concat(o.tags?.map(v => v.id) ?? []);
                        });

                        const pendingValues = await OfflineDataService.getPendingTagValues(customerID, tagIDs, date?.toISOString());

                        const device = projectDevice(offlineDevice, offlineListText, tankStyles, pendingValues, useLKVOffline);

                        // create list of tat/tag groups from the tag data
                        const categories: ITagCategory[] = [];
                        offlineDevice.tags?.filter(o => o.category)
                            .forEach((o) => {
                                const category: ITagCategory = {
                                    id: o.category?.value as number,
                                    text: o.category?.key as string,
                                    order: o.category?.value as number
                                };

                                if (!categories.find(v => v.id === category.id)) {
                                    categories.push(category);
                                }
                            });
                        device.categories = categories;

                        return device;

                    case eLynxObjectTypeEnum.Tank:
                        const offlineTank = offlineObject as IOfflineDevice;

                        let tankTagIDs = offlineTank?.tags?.map(o => o.id) ?? [];

                        const pendingTankValues = await OfflineDataService.getPendingTagValues(customerID, tankTagIDs, date?.toISOString());

                        const tank = projectTank(offlineTank, offlineListText, tankStyles, pendingTankValues, useLKVOffline);

                        // create list of tat/tag groups from the tag data
                        const tankCategories: ITagCategory[] = [];
                        offlineTank.tags?.filter(o => o.category)
                            .forEach((o) => {
                                const category: ITagCategory = {
                                    id: o.category?.value as number,
                                    text: o.category?.key as string,
                                    order: o.category?.value as number
                                };

                                if (!tankCategories.find(v => v.id === category.id)) {
                                    tankCategories.push(category);
                                }
                            });
                        tank.categories = tankCategories;

                        return tank;

                    case eLynxObjectTypeEnum.TankBattery:

                        const offlineTankBattery = offlineObject as IOfflineTankBattery;
                        let tankBatteryTagIDs = offlineTankBattery?.tags?.map(o => o.id) ?? [];

                        offlineTankBattery.tanks?.forEach(o => {
                            tankBatteryTagIDs = tankBatteryTagIDs.concat(o.tags?.map(v => v.id) ?? []);
                        });

                        const pending = await OfflineDataService.getPendingTagValues(customerID, tankBatteryTagIDs, date?.toISOString());
                        return projectTankBattery(offlineTankBattery, offlineListText, tankStyles, pending, useLKVOffline);

                    case eLynxObjectTypeEnum.Well:

                        const offlineWell = offlineObject as IOfflineWell;
                        let wellTagIDs = offlineWell?.tags?.map(o => o.id) ?? [];

                        offlineWell.devices?.forEach(o => {
                            wellTagIDs = wellTagIDs.concat(o.tags?.map(v => v.id) ?? []);
                        });

                        const pendingWellValues = await OfflineDataService.getPendingTagValues(customerID, wellTagIDs, date?.toISOString());
                        const well = projectWell(offlineWell, offlineListText, tankStyles, pendingWellValues, useLKVOffline);

                        // create list of tat/tag groups from the tag data
                        const wellCategories: ITagCategory[] = [];
                        offlineWell.tags?.filter(o => o.category)
                            .forEach((o) => {
                                const category: ITagCategory = {
                                    id: o.category?.value as number,
                                    text: o.category?.key as string,
                                    order: o.category?.value as number
                                };

                                if (!wellCategories.find(v => v.id === category.id)) {
                                    wellCategories.push(category);
                                }
                            });
                        well.categories = wellCategories;

                        return well;


                    default:
                        throw new Error(`get offline data for ${eLynxObject.objectType} not implemented.`);
                }
            }
        }
    },
    saveTagValues: async function (customerID: number,
        values: ITagValue[],
        convertToContractday: boolean,
        offline: boolean,
        signal?: AbortSignal): Promise<void> {

        if (!offline) {
            const path = '/manualentry/values';

            restService.put<ITagValue[], TagValueDataQueryParams, void>(path,
                values,
                signal, {
                //contextGroupID: contextGroupID,
                convertToContractday: convertToContractday
            });
        } else {

            OfflineDataService.saveTagValues(customerID, values);

        }
    },
    exportTagValues: async function(notificationKey: string, 
        groupID: number, 
        eLynxObject: IeLynxObject, 
        mimeType: ApplicationMimeTypesEnum, 
        sortParameters: ISortParameters,
        optionalColumns: Array<string>

    ): Promise<void> {

        const path = `groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/values/export`;

        const params: IObjectTagValuesExportRestQueryParams = {
            notificationKey: notificationKey,
            mimeType: mimeType,
            sortParameters: sortParameters,        
            optionalColumns: optionalColumns ?? []
        };

        await restService.post<IObjectTagValuesExportRestQueryParams, void>(path, params);
    },

    getTagValueCharts: async function (customerID: number,
        contextGroupID: number,
        eLynxObject: IeLynxObject,
        tagAndTatIDs: Array<ITagAndTatID>,
        startDate: Date | undefined,
        endDate: Date | undefined,
        offline: boolean,
        signal?: AbortSignal):
        Promise<ITagHistory | undefined> {

            if (!offline) {
                const queryParams: GetObjectValuesChartsQueryParams = {
                    tagIDTatIDs: tagAndTatIDs,
                    startTime: startDate,
                    endTime: endDate
                };

                const path = `/groups/${contextGroupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/charts`;
                switch (eLynxObject.objectType) {
                    case eLynxObjectTypeEnum.Device:
                        const deviceResponse = await restService.post<GetObjectValuesChartsQueryParams, ITagHistory>(path, queryParams, signal);
                        return deviceResponse.data;

                    // case eLynxObjectTypeEnum.Tank:
                    //     const tankResponse = await restService.get<IEntityValueTankModel>(path, signal);
                    //     setLookupList(tankResponse.data);
                    //     return tankResponse.data;

                    case eLynxObjectTypeEnum.Well:
                        const wellResponse = await restService.post<GetObjectValuesChartsQueryParams, ITagHistory>(path, queryParams, signal);
                        return wellResponse.data;

                    // case eLynxObjectTypeEnum.TankBattery:

                    //     const tankBatteryResponse = await restService.get<ITankBattery>(path, signal);
                    //     return tankBatteryResponse.data;

                    default:
                        throw new Error(`getTagValueCharts not implemented for ${eLynxObject.objectType}`);
                }

            } else {
                throw new Error(`offline mode not implemented for getTagValueCharts`);
            }
    }
};

export default TagValueDataService;